document.addEventListener('DOMContentLoaded', () => {
  if (!document.body.matches('.users_registrations.edit')) return;

  const checkbox = document.querySelector('input[name=fit_screen_layout]');
  if (!checkbox) return;

  checkbox.addEventListener('change', () => {
    checkbox.disabled = true;
    document.cookie = `fit_screen_layout=${checkbox.checked}; path=/`;
    location.reload();
  });
});
